export default __webpack_public_path__ + "9c00a9a00fb45add1ad1c0dc3840e31b.png";